import { takeEvery, takeLatest } from "redux-saga/effects";
import {
  LOG_IN,
  LOG_IN_SSO,
  GET_SSO_ORGANIZATIONS,
  LOG_OUT,
  FORGOT_PASSWORD,
  CONFIRM_OTP
} from "../constants";
import apiCall from "../../utils/apiCall";

const login = apiCall({
  type: LOG_IN,
  method: "post",
  path: "/login"
});

const loginSSO = apiCall({
  type: LOG_IN_SSO,
  method: "post",
  path: "/login/sso"
});

const getSsoOrganizations = apiCall({
  type: GET_SSO_ORGANIZATIONS,
  method: "get",
  path: "/login/sso/organizations"
});

const logout = apiCall({
  type: LOG_OUT,
  method: "post",
  path: "/logout"
});

const forgotPass = apiCall({
  type: FORGOT_PASSWORD,
  method: "post",
  path: "/my/password/forgot"
});

const confirmOTP = apiCall({
  type: CONFIRM_OTP,
  method: "post",
  path: "my/activate"
});

export default function* authSaga() {
  yield takeLatest(LOG_IN, login);
  yield takeLatest(LOG_IN_SSO, loginSSO);
  yield takeLatest(GET_SSO_ORGANIZATIONS, getSsoOrganizations);
  yield takeEvery(LOG_OUT, logout);
  yield takeEvery(FORGOT_PASSWORD, forgotPass);
  yield takeLatest(CONFIRM_OTP, confirmOTP);
}
